import Imatge, { hasImatge } from 'components/3catinfo/Imatge';
import Enllac from 'components/3catinfo/Enllac';
import styles from './destacatInformatiu.module.scss';

const DestacatInformatiu = (props) => {
    const { item, index, infoBlocRedl } = props;
    const { id, titol, imatges, url } = item;
    const hasImatges = hasImatge(imatges, 'web_informatius_destacats', null, null);
    const route = {
        href: url,
        type: 'web_3cat_programa'
    };

    const indexMarcatge = index || 1;
    const marcatgeAudienciesClick = infoBlocRedl
        ? `Tira:${indexMarcatge}:${infoBlocRedl?.descripcio ? infoBlocRedl?.descripcio?.replace(':', '.') : ''}`
        : '';

    return item ? (
        <Enllac
            route={route}
            novaFinestra={true}
            className={styles.poster_destacat_informatiu}
            dataTestId={`poster-destacat-informatius-${id}`}
            marcatgeAudienciesClick={marcatgeAudienciesClick}
        >
            <div className={styles.wrapper}>
                <div className={styles.imatgeWrapper}>
                    {hasImatges && (
                        <Imatge
                            className={styles.imatge}
                            imatges={imatges}
                            tipus='web_informatius_destacats'
                            alt={titol}
                            layout='fill'
                            objectFit='cover'
                        />
                    )}
                </div>
            </div>
        </Enllac>
    ) : (
        <></>
    );
};

export default DestacatInformatiu;
